<mat-expansion-panel [expanded]="autoExpand">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ 'common.labels.filters' | transloco }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">
    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.referenceNumber' | transloco }}</mat-label>
        <input matInput [formControlName]="'referenceNumber'" [placeholder]="'common.labels.referenceNumber' | transloco" />
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-select [formControlName]="'orderTypes'" [placeholder]="'common.labels.orderType' | transloco" multiple="true"
          (selectionChange)="handleOrderTypeChanged($event)">
          @for (option of _orderTypeOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-select [formControlName]="'status'" [placeholder]="'common.labels.orderStatus' | transloco" multiple="true">
          @for (option of _orderStatusTypeOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <lib-jurisdiction-selection  (jurisdictionChosenEvent)="handleJurisdictionFormChange($event)"
      (formReady)="handleJurisdictionFormReady($event)" [defaultCountry]="'CA'" [multiSelect]="true"
    [includeFederal]="true"></lib-jurisdiction-selection>

    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-select [formControlName]="'userGroupID'" [placeholder]="'common.labels.userGroup' | transloco" (selectionChange)="onUserGroupChanged($event)">
          @for (option of _userGroups; track option) {
            <mat-option [value]="option.hasAccessToUserGroupID">
              {{ option.hasAccessToUserGroup?.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (_users.length > 0) {
        <mat-form-field class="form-field flex-item">
          <mat-select [formControlName]="'userID'" [placeholder]="'common.labels.user' | transloco">
            @for (option of _users; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>


    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.dateRequestedFrom' | transloco }}</mat-label>
        <input matInput [matDatepicker]="dateRequestedFrom" [formControlName]="'dateRequestedFrom'"
          [placeholder]="'common.labels.dateRequestedFrom' | transloco">
        <mat-datepicker-toggle matSuffix [for]="dateRequestedFrom"></mat-datepicker-toggle>
        <mat-datepicker #dateRequestedFrom></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.dateRequestedTo' | transloco }}</mat-label>
        <input matInput [matDatepicker]="dateRequestedTo" [formControlName]="'dateRequestedTo'"
          [placeholder]="'common.labels.dateRequestedTo' | transloco" (dateChange)="updateRequestedDateTo()">
        <mat-datepicker-toggle matSuffix [for]="dateRequestedTo"></mat-datepicker-toggle>
        <mat-datepicker #dateRequestedTo></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.dateLastUpdatedFrom' | transloco }}</mat-label>
        <input matInput [matDatepicker]="orderStatusUpdatedDateFrom"
          [formControlName]="'orderStatusUpdatedDateFrom'" [placeholder]="'common.labels.dateLastUpdatedFrom' | transloco">
        <mat-datepicker-toggle matSuffix [for]="orderStatusUpdatedDateFrom"></mat-datepicker-toggle>
        <mat-datepicker #orderStatusUpdatedDateFrom></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.dateLastUpdatedTo' | transloco }}</mat-label>
        <input matInput [matDatepicker]="orderStatusUpdatedDateTo" [formControlName]="'orderStatusUpdatedDateTo'"
          [placeholder]="'common.labels.dateLastUpdatedTo' | transloco" (dateChange)="updateStateDateTo()">
        <mat-datepicker-toggle matSuffix [for]="orderStatusUpdatedDateTo"></mat-datepicker-toggle>
        <mat-datepicker #orderStatusUpdatedDateTo></mat-datepicker>
      </mat-form-field>
    </div>

    @if (_lienOrderTypeSelected) {
      <div>
        <div class="flex-container">
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.registration' | transloco }}</mat-label>
            <input matInput [formControlName]="'registrationOrFileNumber'" [placeholder]="'common.labels.registration' | transloco" />
          </mat-form-field>
          @if (_qcFormTypesVisible) {
            <mat-form-field class="form-field flex-item">
              <mat-select [formControlName]="'QCFormTypeIDs'" [placeholder]="'common.labels.form' | transloco" multiple="true">
                @for (option of _qcFormTypeOptionsVisible; track option) {
                  <mat-option [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
        <div class="flex-container">
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.registrationDateFrom' | transloco }}</mat-label>
            <input matInput [matDatepicker]="registrationDateFrom"
              [formControlName]="'registrationDateFrom'" [placeholder]="'common.labels.registrationDateFrom' | transloco">
            <mat-datepicker-toggle matSuffix [for]="registrationDateFrom"></mat-datepicker-toggle>
            <mat-datepicker #registrationDateFrom></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.registrationDateTo' | transloco }}</mat-label>
            <input matInput [matDatepicker]="registrationDateTo" [formControlName]="'registrationDateTo'"
              [placeholder]="'common.labels.registrationDateTo' | transloco" (dateChange)="updateRegistrationDateTo()">
            <mat-datepicker-toggle matSuffix [for]="registrationDateTo"></mat-datepicker-toggle>
            <mat-datepicker #registrationDateTo></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    }

    <div class="spacer-small"></div>
    <mat-divider></mat-divider>
    <div class="spacer-small"></div>

    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
        <input matInput [formControlName]="'firstName'" [placeholder]="'common.labels.firstName' | transloco" />
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
        <input matInput [formControlName]="'lastName'" [placeholder]="'common.labels.lastName' | transloco" />
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.dateOfBirth' | transloco }}</mat-label>
        <input matInput [matDatepicker]="dateOfBirth" [formControlName]="'dateOfBirth'"
          [placeholder]="'common.labels.dateOfBirth' | transloco">
        <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
        <mat-datepicker #dateOfBirth></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.businessName' | transloco }}</mat-label>
        <input matInput [formControlName]="'businessName'" [placeholder]="'common.labels.businessName' | transloco" />
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.businessNumber' | transloco }}</mat-label>
        <input matInput [formControlName]="'businessNumber'" [placeholder]="'common.labels.businessNumber' | transloco" />
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.serialNumber' | transloco }}</mat-label>
        <input matInput [formControlName]="'serialNumber'" [placeholder]="'common.labels.serialNumber' | transloco" />
      </mat-form-field>
    </div>
    <div class="spacer-small"></div>
    <div>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ 'common.labels.clearFilters' | transloco }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ 'common.labels.filter' | transloco }}
      </button>
    </div>
  </form>
</mat-expansion-panel>